import { put, call, all, takeLatest, select } from "redux-saga/effects";
import * as types from "./supporterType";
import * as supporterApi from "./supporterApi";
import { getBaseUrl } from "~/utils/getBaseUrl";

function* getUserDetailWorker({ data, callback }) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(supporterApi.getUserDetail, baseUrl, data);
    if (response.status !== 200 || response.data.error_code)
      throw new Error("Server error");
    yield put({
      type: types.GET_USER_DETAIL_SUCCESS,
      userDetail: response.data
    });
    callback();
  } catch (error) {
    yield put({
      type: types.GET_USER_DETAIL_FAILURE,
      errorMessage: error.errorMessage
    });
  }
}

function* getPatientWorker({ data }) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(supporterApi.getPatient, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    yield put({ type: types.GET_PATIENT_SUCCESS, patientList: response.data });
  } catch (error) {
    yield put({
      type: types.GET_PATIENT_FAILURE,
      errorMessage: error.errorMessage
    });
  }
}

function* getSupporterWorker({ data }) {
  try {
    yield put({ type: types.SHOW_LOADING });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(supporterApi.getSupporter, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    yield put({
      type: types.GET_SUPPORTER_SUCCESS,
      supporterList: response.data
    });
    yield put({ type: types.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: types.GET_SUPPORTER_FAILURE,
      errorMessage: error.errorMessage
    });
    yield put({ type: types.HIDE_LOADING });
  }
}

function* followSupporterWorker({ data, callback }) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(supporterApi.followSupporter, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    yield put({
      type: types.FOLLOW_SUPPORTER_SUCCESS,
      status: response.data.status
    });
    callback();
  } catch (error) {
    yield put({
      type: types.FOLLOW_SUPPORTER_FAILURE,
      errorMessage: error.errorMessage
    });
  }
}

function* getFollowSupporterWorker({ data }) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(supporterApi.getFollowSupporter, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    yield put({
      type: types.GET_FOLLOW_SUPPORTER_SUCCESS,
      supporterFollowList: response.data
    });
  } catch (error) {
    yield put({
      type: types.GET_FOLLOW_SUPPORTER_FAILURE,
      errorMessage: error.errorMessage
    });
  }
}

function* getHistoryChatWorker({ data, callback }) {
  try {
    // console.log(callback)
    yield put({ type: types.SHOW_LOADING_HISTORY });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(supporterApi.getHistoryChat, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");

    // callback({
    //   supporter_id: data.supporter_id,
    //   offset: 0,
    //   limit: 100,
    // })
    yield put({
      type: types.GET_HISTORY_CHAT_SUCCESS,
      historyChatList: response.data.data,
      totalHistoryChat: response.data.total
    });
    // callback()
    yield put({ type: types.HIDE_LOADING_HISTORY });
  } catch (error) {
    yield put({
      type: types.GET_HISTORY_CHAT_FAILURE,
      errorMessage: error.errorMessage
    });
    yield put({ type: types.HIDE_LOADING_HISTORY });
  }
}

function* getPatientChatedWorker({ data }) {
  try {
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(supporterApi.getPatientChated, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    yield put({
      type: types.GET_PATIENT_CHATED_SUCCESS,
      patientChatedList: response.data.data,
      totalPatientChated: response.data.total
    });
  } catch (error) {
    yield put({
      type: types.GET_PATIENT_CHATED_FAILURE,
      errorMessage: error.errorMessage
    });
  }
}

export default function* watcher() {
  yield all([
    takeLatest(types.GET_USER_DETAIL_REQUEST, getUserDetailWorker),
    takeLatest(types.GET_PATIENT_REQUEST, getPatientWorker),
    takeLatest(types.GET_SUPPORTER_REQUEST, getSupporterWorker),
    takeLatest(types.FOLLOW_SUPPORTER_REQUEST, followSupporterWorker),
    takeLatest(types.GET_FOLLOW_SUPPORTER_REQUEST, getFollowSupporterWorker),
    takeLatest(types.GET_HISTORY_CHAT_REQUEST, getHistoryChatWorker),
    takeLatest(types.GET_PATIENT_CHATED_REQUEST, getPatientChatedWorker)
  ]);
}
